import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const AdminStatsCard = ({ icon, title, value, color, delay = 0, caption }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 1200;
    const steps = 40;
    const stepValue = value / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += stepValue;
      if (current >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  const tones = {
    orange: {
      surface: "from-[#fff1df] to-white",
      chip: "bg-[#ff9933] text-white",
      accent: "bg-[#ff9933]",
    },
    green: {
      surface: "from-[#edf8ef] to-white",
      chip: "bg-[#138808] text-white",
      accent: "bg-[#138808]",
    },
    red: {
      surface: "from-[#fff0ec] to-white",
      chip: "bg-[#d95d39] text-white",
      accent: "bg-[#d95d39]",
    },
    blue: {
      surface: "from-[#eef4ff] to-white",
      chip: "bg-[#2f6fed] text-white",
      accent: "bg-[#2f6fed]",
    },
  };

  const tone = tones[color] || tones.orange;

  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.35 }}
      className={`overflow-hidden rounded-[1.75rem] border border-[#d7dfd4] bg-gradient-to-br ${tone.surface} p-5 shadow-sm`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">{title}</p>
          <motion.p
            initial={{ scale: 0.85 }}
            animate={{ scale: 1 }}
            transition={{ delay: delay + 0.08, type: "spring", stiffness: 180 }}
            className="text-3xl font-semibold tracking-tight text-slate-900"
          >
            {count.toLocaleString()}
          </motion.p>
          <p className="text-sm text-slate-500">{caption || "Live count from admin services"}</p>
        </div>

        <div className={`inline-flex rounded-2xl px-3 py-2 text-sm font-semibold shadow-sm ${tone.chip}`}>
          {icon}
        </div>
      </div>

      <div className="mt-5 h-1.5 overflow-hidden rounded-full bg-white/80">
        <div className={`h-full w-2/3 rounded-full ${tone.accent}`} />
      </div>
    </motion.div>
  );
};

export default AdminStatsCard;
